import React from 'react';
import { connect } from 'react-redux';
import Form from '../../../components/form/form';
import Message from '../../../components/message/index';
import Breadcrumb from '../../../components/breadcrumb/index';
import moment from 'moment';
import { dailyReport, exportOmsgReport, virtualNumberList } from '../../../actions/actions';
import { scrollToTop } from '../../../actions/utils';
import Select from '../../../components/form/select';


class DailyReport extends React.Component {
    constructor(props)
    {
        super(props)
        this.reportRef = React.createRef();

        const setOriginatorList = event => {
            let selectedVirtualNumber = event.target.value;
            let virtualNumberListDataObj = this.state.virtualNumberList;
            let selectedOriginatorList = virtualNumberListDataObj.filter(object => object.product.virtualNumber === selectedVirtualNumber)[0].product.originators;

            this.setState({
                formModel: {
                    ...this.state.formModel,
                    virtualNumber: {
                        ...this.state.formModel.virtualNumber,
                        value: selectedVirtualNumber
                    },
                    originator: {
                        ...this.state.formModel.originator,
                        options: selectedOriginatorList.map(x => ({value:x, name:x})),
                        value: selectedOriginatorList[0]
                    }
                }
            })
        };

        this.state = {
            itemDetailsToShow: [],
            list: [],
            pageSize: 0,
            pageNumber: 0,
            totalItemCount: 0,
            downloadOptions: {
                value: 'PDF',
                name: 'downloadOptions',
                type: 'select',
                label: '',
                placeholder: 'Dosya Tipi',
                options: [{name: 'PDF', value: 'pdf'},{name: 'Excel', value: 'xlsx'}],
                error: 'Lütfen dosya tipi seçiniz.',
                valid: true,
                touched: false,
                validationRules: {
                    isRequired: true
                }
            },
            formModel: {
                virtualNumber: {
                    value: '',
                    name: 'virtualNumber',
                    type: 'select',
                    label: 'Sanal Numara',
                    placeholder: 'Sanal Numara',
                    error: 'Lütfen Sanal Numara girin.',
                    options: [],
                    valid: false,
                    touched: false,
                    handleChange: setOriginatorList,
                    validationRules: {
                        isRequired: true
                    }
                },
                originator: {
                    value: '',
                    name: 'originator',
                    type: 'select',
                    label: 'SMS Başlık',
                    placeholder: 'SMS Başlık',
                    error: 'Lütfen SMS Başlık girin.',
                    options: [],
                    valid: false,
                    touched: false,
                    validationRules: {
                        isRequired: true
                    }
                },
                startDate: {
                    value: '',
                    name: 'startDate',
                    type: 'textdate',
                    label: 'Başlangıç Tarihi',
                    placeholder: 'Başlangıç Tarihi',
                    error: 'Lütfen Başlangıç Tarihi girin.',
                    valid: false,
                    touched: false,
                    validationRules: {
                        isRequired: true,
                        isDate: true
                    }
                },
                endDate: {
                    value: '',
                    name: 'endDate',
                    type: 'textdate',
                    label: 'Bitiş Tarihi',
                    placeholder: 'Bitiş Tarihi',
                    error: 'Lütfen Bitiş Tarihi girin.',
                    valid: false,
                    touched: false,
                    validationRules: {
                        isRequired: true,
                        isDate: true
                    }
                },
            }
        };

        this.getVirtualNumberList();
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(data)
    {
        this.getReport(data);
    }

    getReport(data){
        var foundedObj = this.state.virtualNumberList.find(vm => vm.product.virtualNumber === data.virtualNumber).product;
        foundedObj.tariff = foundedObj.tariffPlan;
        this.props.dispatch(dailyReport({...data, ...foundedObj}, (response) => {
            this.setState({
                itemDetailsToShow: [],
                list: response.reportItems,
                pageNumber: response.pageNumber,
            });
        }, (data) => {
            scrollToTop();
        }));
    }

    getVirtualNumberList(){
        this.props.dispatch(virtualNumberList((response) => {
        }, (data) => {
            if(data != null) {
                this.setState({
                    virtualNumberList: data,
                    formModel: {
                        ...this.state.formModel,
                        virtualNumber: {
                            ...this.state.formModel.virtualNumber,
                            options: data.map(x => ({value: x.product.virtualNumber, name: x.product.virtualNumber})),
                            value: data[0].product.virtualNumber
                        },
                        originator: {
                            ...this.state.formModel.originator,
                            options: data[0].product.originators.map(x => ({value: x, name: x})),
                            value: data[0].product.originators[0]
                        }
                    }
                })
            }
        }));

    }


    downloadReport() {
        if(this.state.downloadOptions.value !== '') {
            var foundedObj = this.state.virtualNumberList.find(vm => vm.product.virtualNumber === this.state.formModel.virtualNumber.value).product;
            foundedObj.tariff = foundedObj.tariffPlan;
            let requestData = {
                type: 'daily',
                docType: this.state.downloadOptions.value,
                reportRequest: {
                    originator:this.state.formModel.originator.value,
                    startDate: this.formatDate(this.state.formModel.startDate.value),
                    endDate: this.formatDate(this.state.formModel.endDate.value),
                    pageNumber: this.state.pageNumber,
                    ...foundedObj
                }
            }
            this.props.dispatch(exportOmsgReport(requestData, () => {
            }, () => {
    
            }));
        }
    }

    async changePage(nextPageNumber){
        if(nextPageNumber === -1 && this.state.pageNumber === 0) {

        } else {
            this.getReport({
                originator:this.state.formModel.originator.value,
                startDate: this.formatDate(this.state.formModel.startDate.value),
                endDate: this.formatDate(this.state.formModel.endDate.value), pageNumber: nextPageNumber});
        }
    }

    formatDate(value){
        let dateValues = value.split('.');
        if(dateValues.length === 3)
        {
          value = dateValues[0] + dateValues[1] + dateValues[2];
        }
        return value;
    }

    handleSelectDownloadOption(data){
        if(data.target.value !== '') {
            this.setState({downloadOptions: {...this.state.downloadOptions, value: data.target.value}})
        } else{
            this.setState({downloadOptions: {...this.state.downloadOptions, value: data.target.value}})
        }
    }

    render() {
        const breadcrumbItems = [{
            name: "Günlük Rapor"
        }];

        return (
        [
            <Breadcrumb items={breadcrumbItems} />,
            <section className="panel">
                <Message />
                <div className="container">
                    <div className="reports">
                        <div className="title-default">
                            <span>Günlük Rapor</span>
                        </div>
                        <div className="report-form">
                            <Form model={this.state.formModel} handleSubmit={this.handleSubmit} smallTitle={""} buttonText={"Rapor Oluştur"} buttonId={"report-list-filter"} multipleColumn={true} />
                        </div>  
                        {this.state.list.length > 0 && 
                        <div>
                               <div style={{display: 'table', textAlign:'center', width: '100%', margin:'10px 0 10px 0'}}>
                            <div style={{display:'table-cell', width:'50vh', verticalAlign:'middle', paddingRight:'5px'}}>
                            <Select data={this.state.downloadOptions} handleChange={this.handleSelectDownloadOption.bind(this)} />

                            </div>
                            <div style={{display:'table-cell', width:'50vh', paddingLeft:'5px'}}>
                            <a id="report-send-download" className="btn primary" href="javascript:void(0)" title="Tümünü indir" onClick={this.downloadReport.bind(this)}>
                                                    <span>Tümünü indir</span>
                                                </a>
                            </div>
                        </div>
                                <div className="report-items">
                                    <div ref={this.reportRef} className="head custom-report-head">
                                        <div className="item custom-daily-report-head">
                                            <div>Sanal Numara</div>
                                            <div>Tarife Adı</div>
                                            <div>Tarih</div>
                                            <div>Toplam Gönderilen Mesaj Adedi</div>
                                            <div>Başarılı Mesaj Adedi</div>
                                            <div>Bekleyen Mesaj Adedi</div>
                                            <div>Başarısız Mesaj Adedi</div>
                                        </div>
                                    </div>
                                    <div className="body">
                                        {this.state.list.map((item, i) =>
                                            <div className="item custom-daily-report-item">
                                                <div>
                                                    <span className="label">Sanal Numara</span>
                                                    <span>{item.companyMsisdn}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Tarife Adı</span>
                                                    <span>{item.tariff}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Tarih</span>
                                                    <span>{moment(item.date).format('DD.MM.YYYY')}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Toplam Gönderilen Mesaj Adedi</span>
                                                    <span>{item.smsTotal}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Başarılı Mesaj Adedi</span>
                                                    <span>{item.success}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Bekleyen Mesaj Adedi</span>
                                                    <span>{item.pending}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Başarısız Mesaj Adedi</span>
                                                    <span>{item.failedTotal}</span>
                                                </div>
                                            </div>
                                            )}
                                    </div>
                                </div>
                          
                        </div>
                          }
                        {this.state.list.length > 0 &&
                            <div className="paging">
                                {this.state.pageNumber !== 0 && <a href="javascript:void(0)" className={"first-item"} onClick={() => this.changePage(-1)}>&lt;&lt;</a>}
                                <a href="javascript:void(0)" className={"last-item"}  onClick={() => this.changePage(+1)}>&gt;&gt;</a>
                            </div>
                        }
                      </div>
                </div>
            </section>
        ]
      );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app 
    }
}


export default connect(mapStateToProps)(DailyReport)